class ZerokitMotion {
  constructor(root) {
    this.root = root;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.items = this.decorate();
    if (!this.items.length || this.reduced || !('IntersectionObserver' in window)) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    this.root.dataset.zkMotion = 'ready';
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    this.items.forEach((item) => this.observer.observe(item));
  }

  decorate() {
    const selectors = [
      '[class$="__eyebrow"]', '[class$="__heading"]', '[class$="__title"]',
      '[class$="__body"]', '[class$="__layout"]', '[class$="__visual"]',
      '[class$="__media"]', '[class$="__grid"]', '[class$="__accordion"]'
    ];
    const items = Array.from(this.root.querySelectorAll(selectors.join(',')))
      .filter((item) => !item.closest('[aria-hidden="true"]'));
    items.forEach((item, index) => {
      if (!item.hasAttribute('data-zk-reveal')) item.dataset.zkReveal = 'fade-up';
      item.style.setProperty('--zk-reveal-delay', `${Math.min(index, 4) * 70}ms`);
    });
    this.root.querySelectorAll('[class*="__card"], [class*="__item"], [class*="__step"]').forEach((item, index) => {
      if (!item.hasAttribute('data-zk-reveal')) item.dataset.zkReveal = 'fade-up';
      item.style.setProperty('--zk-reveal-delay', `${Math.min(index, 5) * 65}ms`);
      items.push(item);
    });
    return [...new Set(items)];
  }

  destroy() {
    this.observer?.disconnect();
    delete this.root.dataset.zkMotion;
  }
}

const instances = new WeakMap();
const selector = 'main section[class^="zk-"], main section[class*=" zk-"]';

function init(scope = document) {
  const roots = scope.matches?.(selector) ? [scope] : Array.from(scope.querySelectorAll?.(selector) || []);
  roots.forEach((root) => {
    if (!instances.has(root)) instances.set(root, new ZerokitMotion(root));
  });
}

function destroy(scope) {
  const roots = scope.matches?.(selector) ? [scope] : Array.from(scope.querySelectorAll?.(selector) || []);
  roots.forEach((root) => {
    instances.get(root)?.destroy();
    instances.delete(root);
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
else init();

document.addEventListener('shopify:section:load', (event) => init(event.target));
document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
